import type { Locales } from "@/app/lang/types.ts";
import { DEFAULT_LANG } from "@/app/lang/constants";
import { LOCAL_STORAGE_KEYS } from "@/app/localStorage/model";

export function getDefaultLang() {
  return (
    (localStorage.getItem(LOCAL_STORAGE_KEYS.LANG) as Locales) || DEFAULT_LANG
  );
}

export const defaultLang = getDefaultLang();
